import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { AdfPage } from './adf-page';
import { IonicStepperModule } from 'ionic-stepper';
import { Stepper } from './component/stepper/stepper';
import { PrimaryForm } from './component/primary-applicant/primary-form/primary';
import { TextMaskModule } from 'angular2-text-mask';
import { AdditionalContact } from './component/primary-applicant/additional-contact/additional-contact';
import { DependentDetails } from './component/dependent-and-family/dependent-details/dependent-details';
import { PrimaryGoal } from './component/primary-applicant/primary-goal/primary-goal';
import { AddressDetail } from './component/primary-applicant/address-detail/address-detail';
import { EmploymentDetails } from './component/employment-and-incomedetails/employment-details/employment_details';
import { IncomeDetails } from './component/employment-and-incomedetails/income-details/income_details';
import { AssetsForm } from './component/assets-and-liablities/assets/assets';
import { LiablitiesForm } from './component/assets-and-liablities/liablities/liablities';
import { RealEstateAssets } from './component/real-estate-assets/real-estate-assets';

@NgModule({
  declarations: [
    AdfPage,
    Stepper,
    PrimaryForm,
    AdditionalContact,
    DependentDetails,
    PrimaryGoal,
    AddressDetail,
    EmploymentDetails,
    IncomeDetails,
    AssetsForm,
    LiablitiesForm,
    RealEstateAssets
  ],
  imports: [
    IonicStepperModule,
    IonicPageModule.forChild(AdfPage),
    TextMaskModule
  ],
  exports:[
    AdfPage,
    Stepper,
    PrimaryForm,
    AdditionalContact,
    DependentDetails,
    PrimaryGoal,
    AddressDetail,
    EmploymentDetails,
    IncomeDetails,
    AssetsForm,
    LiablitiesForm,
    RealEstateAssets
  ]
})
export class AdfPageModule {}



// WEBPACK FOOTER //
// ./src/pages/adf-page/adf-page.module.ts